<template>
    <div
        :class="(setClass ? setClass : '') + ' layering_section layer-object-toolbar'"
    >
        <div class="layer_parent_div layer_main_custom_box">
            <button
                type="button"
                @click="setValue('back')"
                :class="'bcommon b1 first ' + setActive('back')"
            >
                <img
                    src="./icon/layer1.png"
                    style="transform: rotate(180deg)"
                />
            </button>
            <button
                type="button"
                @click="setValue('front')"
                :class="'bcommon b2 last ' + setActive('front')"
            >
                <img src="./icon/layer2.png" />
            </button>
        </div>
        <label>Layering</label>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Layering",
    /* eslint-enable */
    props: ["value", "setClass"],
    data: () => {
        return {};
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", e);
        },
        setActive(e) {
            return e == this.value ? "active" : "";
        }
    }
};
</script>

<style>
.layer_parent_div {
    display: flex;
    align-items: stretch;
    width: 100%;
    margin: 0px 15px;
}

.bcommon {
    background-color: initial;
    color: #7796a8;
    border: 1px solid;
    border-radius: 0 !important;
    background: #7796a8;
    width: 40px;
}

.b1 {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
}

.b2 {
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}

/*
 * Same as Flip / Center: inactive #fff, active #e8e8e8.
 * Include .center_main_box_layer_custom so we beat global
 * div:first-child button { background: transparent !important } on Layering.
 */
.design_studio_tool
    div#add-text
    .center_layering_filip.center_main_box_layer_custom
    .layering_section.layer-object-toolbar
    button.bcommon:not(.active),
.design_studio_up
    .design_studio_tool
    div#add-text
    .center_layering_filip.center_main_box_layer_custom
    .layering_section.layer-object-toolbar
    button.bcommon:not(.active) {
    background: #ffffff !important;
    border: 1px solid #707070 !important;
}

.design_studio_tool
    div#add-text
    .center_layering_filip.center_main_box_layer_custom
    .layering_section.layer-object-toolbar
    button.bcommon.active,
.design_studio_up
    .design_studio_tool
    div#add-text
    .center_layering_filip.center_main_box_layer_custom
    .layering_section.layer-object-toolbar
    button.bcommon.active {
    background: #e8e8e8 !important;
    border: 1px solid #707070 !important;
}

.design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .layering_section.layer-object-toolbar
    button.bcommon:not(.active),
.design_studio_up
    .design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .layering_section.layer-object-toolbar
    button.bcommon:not(.active) {
    background: #ffffff !important;
    border: 1px solid #707070 !important;
}

.design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .layering_section.layer-object-toolbar
    button.bcommon.active,
.design_studio_up
    .design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .layering_section.layer-object-toolbar
    button.bcommon.active {
    background: #e8e8e8 !important;
    border: 1px solid #707070 !important;
}
</style>
